import { QGetSports } from "./QGetSports";
import { QGetSportsGroupedByDate } from "./QGetSportsGroupedByDate";
import { QGetLeaguesBySportId } from "./QGetLeaguesBySportId";
import { QGetLeaguesByLeagueId } from "./QGetLeaguesByLeagueId";
import { QGetTopLeaguesBySportId } from "./QGetTopLeaguesBySportId";
import { QGetEventsBySportId } from "./QGetEventsBySportId";
import { QGetEventsByEventId } from "./QGetEventsByEventId";
import { QGetEventsByEventIdOrByLeagueId } from "./QGetEventsByEventIdOrByLeagueId";
import { QGetEventsByLeagueId } from "./QGetEventsByLeagueId";
import { QGetEventsFromTopLeaguesBySportId } from "./QGetEventsFromTopLeaguesBySportId";
import { QGetEventsCountByTag } from "./QGetEventsCountByTag";
import { QGetEventsByRegionIdAndSportId } from "./QGetEventsByRegionIdAndSportId";
import { QGetPersonalizedLiveEvents } from "./QGetPersonalizedLiveEvents";
import { QGetEventsByEventIdForBetSlip } from "./QGetEventsByEventIdForBetSlip";
export const QueryBuilder = {
    getSports: QGetSports,
    getSportsGroupedByDate: QGetSportsGroupedByDate,
    getLeaguesBySportId: QGetLeaguesBySportId,
    getLeaguesByLeagueId: QGetLeaguesByLeagueId,
    getTopLeaguesBySportId: QGetTopLeaguesBySportId,
    getEventsBySportId: QGetEventsBySportId,
    getEventsByEventId: QGetEventsByEventId,
    getEventsByEventIdOrByLeagueId: QGetEventsByEventIdOrByLeagueId,
    getEventsByLeagueId: QGetEventsByLeagueId,
    getEventsFromTopLeaguesBySportId: QGetEventsFromTopLeaguesBySportId,
    getEventsCountByTag: QGetEventsCountByTag,
    getEventsByRegionIdAndSportId: QGetEventsByRegionIdAndSportId,
    getPersonalizedLiveEvents: QGetPersonalizedLiveEvents,
    getEventsByEventIdForBetSlip: QGetEventsByEventIdForBetSlip
};
//# sourceMappingURL=index.js.map